function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.6667 13.3335L14 14.6668V1.3335H2V14.6668L5.33333 13.3335L8 14.6668L10.6667 13.3335ZM8 13.1761L10.6059 11.8732L12.6667 12.6975V2.66683H3.33333V12.6975L5.39408 11.8732L8 13.1761Z",
  fill: "#07003D",
  fillOpacity: 0.2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.66666 4H11.3333V5.33333H4.66666V4Z",
  fill: "#07003D",
  fillOpacity: 0.2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.66666 6.6665H8.66666V7.99984H4.66666V6.6665Z",
  fill: "#07003D",
  fillOpacity: 0.2
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M4.66666 9.3335H10.6667V10.6668H4.66666V9.3335Z",
  fill: "#07003D",
  fillOpacity: 0.2
});

var SvgReceipt = function SvgReceipt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReceipt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/receipt.50628ca3.svg";
export { ForwardRef as ReactComponent };